import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HelpConfig } from '@config/help-config';
import { NotificacaoModel } from '@core/models/gestao/notificacao.model';
import { BaseResourceService } from '@core/services/outros/base-resource.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationService extends BaseResourceService<NotificacaoModel> {

    constructor(
        protected injector: Injector,
        private helpConfig: HelpConfig
    ) {
        super(`${helpConfig.MANAGEMENT_API}notificacao`, injector);
    }

    saveRead(notification: NotificacaoModel): Observable<NotificacaoModel> {
        return this._httpClient.post<NotificacaoModel>(`${this._url}/read`, notification);
    }

    getNotificationsTypeStudent(): Observable<NotificacaoModel[]> {
        return this._httpClient.get<NotificacaoModel[]>(`${this._url}?tipo=ALUNO&Situacao=PUBLICADA`);
    }
}
